import React from 'react';
export const DatasetDetailsModal = ({
  dataset,
  onClose,
  onViewErrors
}) => {
  return <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50" data-id="element-470">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-md" data-id="element-471">
        <div className="flex justify-between items-center border-b border-gray-200 px-6 py-4" data-id="element-472">
          <h3 className="text-lg font-medium text-gray-900" data-id="element-473">
            Dataset: {dataset.name}
          </h3>
          <button className="text-gray-400 hover:text-gray-500" onClick={onClose} data-id="element-474">
            <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-475">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" data-id="element-476" />
            </svg>
          </button>
        </div>
        <div className="p-6" data-id="element-477">
          <div className="mb-6" data-id="element-478">
            <div className="flex items-start mb-4" data-id="element-479">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-blue-500 mr-3 mt-0.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-480">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" data-id="element-481" />
              </svg>
              <div data-id="element-482">
                <h4 className="font-medium text-gray-900" data-id="element-483">
                  Dataset Information
                </h4>
                <p className="text-sm text-gray-500" data-id="element-484">
                  Detailed information about this dataset.
                </p>
              </div>
            </div>
            <div className="flex items-start mb-4" data-id="element-485">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-gray-400 mr-3 mt-0.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-486">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 12h14M5 12a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v4a2 2 0 01-2 2M5 12a2 2 0 00-2 2v4a2 2 0 002 2h14a2 2 0 002-2v-4a2 2 0 00-2-2m-2-4h.01M17 16h.01" data-id="element-487" />
              </svg>
              <div data-id="element-488">
                <h4 className="font-medium text-gray-700" data-id="element-489">Source System</h4>
                <p className="text-sm text-gray-900" data-id="element-490">{dataset.source}</p>
              </div>
            </div>
            <div className="flex items-start mb-4" data-id="element-491">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-gray-400 mr-3 mt-0.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-492">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" data-id="element-493" />
              </svg>
              <div data-id="element-494">
                <h4 className="font-medium text-gray-700" data-id="element-495">Last Updated</h4>
                <p className="text-sm text-gray-900" data-id="element-496">{dataset.lastUpdate}</p>
              </div>
            </div>
            <div className="flex items-start mb-4" data-id="element-497">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-gray-400 mr-3 mt-0.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-498">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1" data-id="element-499" />
              </svg>
              <div data-id="element-500">
                <h4 className="font-medium text-gray-700" data-id="element-501">Connection Type</h4>
                <p className="text-sm text-gray-900" data-id="element-502">{dataset.connection}</p>
              </div>
            </div>
            {dataset.status === 'error' && <div className="flex items-start" data-id="element-503">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-red-500 mr-3 mt-0.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-504">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" data-id="element-505" />
                </svg>
                <div data-id="element-506">
                  <h4 className="font-medium text-red-600" data-id="element-507">Status</h4>
                  <p className="text-sm text-red-600" data-id="element-508">
                    {dataset.errorCount} Errors detected
                  </p>
                  <p className="text-sm text-gray-500" data-id="element-509">
                    Please check the connection configuration and try again.
                  </p>
                </div>
              </div>}
          </div>
          <div className="flex justify-between gap-3" data-id="element-510">
            {dataset.status === 'error' && <button className="flex-1 px-4 py-2 border border-red-300 text-red-700 rounded-md hover:bg-red-50 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2" onClick={onViewErrors} data-id="element-511">
                View Errors
              </button>}
            <button className="flex-1 px-4 py-2 border border-gray-300 text-gray-700 rounded-md hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2" data-id="element-512">
              Edit Connection
            </button>
            <button className="flex-1 px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2" data-id="element-513">
              Refresh Data
            </button>
          </div>
        </div>
      </div>
    </div>;
};